export const EXERCISE_GAP_FILL_WITH_HINT = 'exercise-gap-fill-with-hint';
export const EXERCISE_GAP_FILL_WITH_HINT_QUESTION = 'exercise-gap-fill-with-hint-question';
export const EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT =
  'exercise-gap-fill-with-hint-question-content';
export const EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTIONS =
  'exercise-gap-fill-with-hint-question-options';
export const EXERCISE_GAP_FILL_WITH_HINT_QUESTION_OPTION =
  'exercise-gap-fill-with-hint-question-option';

export type ExerciseGapFillWitHintOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type ExerciseGapFillWithHintQuestionOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type CreteGapFillWithHintQuestionOptions = {
  question?: string;
  options?: string[];
  correctOptions?: string[];
};
